export type User = {
  id: string;
  name: string;
  venmo?: string;
};

export function createNewUser(name: string, venmo?: string) {
  return {
    id: crypto.randomUUID(),
    name,
    venmo,
  } as User;
}
